// extracted by mini-css-extract-plugin
module.exports = {"root":"_dd0385","product":"_a7d7b5","info":"_219dda","clickoutIcon":"_d3b98f","logoContainer":"_d945bd","logo":"_840c3b","title":"_3f2245","highlyRatedFor":"_d02238"};